<content-nav-bar>
    <!-- LG+ Screens (1024px+): full horizontal nav with hover-grace Configuration dropdown -->
    <div class="hidden lg:block bg-gray-100 shadow-sm border-b border-gray-200 mb-6 relative z-10">
        <div class="flex items-center gap-1 px-4 py-2 flex-wrap">
            <button each="{item in state.topItems}"
                    onclick="{() => navigateToPage(item.route)}"
                    class="btn btn-sm gap-1 cursor-pointer {isActive(item.route) ? 'btn-primary' : 'btn-ghost'} whitespace-nowrap">
                <i class="{item.icon}"></i>
                <span class="text-sm">{item.label}</span>
            </button>

            <span class="flex-grow"></span>

            <div if="{state.isAdmin}"
                 class="content-dropdown-item flex-shrink-0"
                 data-category-id="configuration"
                 onkeydown="{handleDropdownKeydown}"
                 onfocusout="{handleDropdownFocusout}">
                <button type="button"
                        onclick="{(e) => toggleDropdown(e.currentTarget)}"
                        aria-haspopup="menu"
                        aria-expanded="false"
                        aria-controls="content-dropdown-menu-configuration"
                        class="btn btn-sm gap-1 cursor-pointer {isActiveConfig() ? 'btn-primary' : 'btn-ghost'} {isActiveConfig() ? '' : 'whitespace-nowrap'}">
                    <i if="{!isActiveConfig()}" class="icon-metalark-settings"></i>
                    <i if="{isActiveConfig()}" class="{getActiveConfigIcon()} me-1"></i>
                    <span class="text-sm">{isActiveConfig() ? getConfigBreadcrumbLabel() : locale?.t('nav_configuration')}</span>
                    <svg class="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"></path>
                    </svg>
                </button>

                <ul id="content-dropdown-menu-configuration"
                    class="content-dropdown-menu menu p-2 shadow bg-base-100 rounded-box w-52 z-[100]">
                    <template each="{item in state.configItems}">
                        <li>
                            <button type="button" onclick="{() => navigateToPage(item.route)}" class="{isActive(item.route) ? 'active' : ''}">
                                <i class="{item.icon}"></i>
                                <span>{item.label}</span>
                            </button>
                        </li>
                    </template>
                </ul>
            </div>
        </div>
    </div>

    <!-- MD Screens (768-1023px): icon-only with tooltips, Configuration as right-aligned dropdown -->
    <div class="hidden md:block lg:hidden bg-gray-100 shadow-sm border-b border-gray-200 mb-6">
        <div class="flex items-center gap-1 px-4 py-2">
            <button
                each="{item in state.topItems}"
                class="btn btn-sm {isActive(item.route) ? 'btn-primary' : 'btn-ghost'} gap-1 whitespace-nowrap flex-shrink-0 tooltip tooltip-bottom"
                data-tip="{item.label}"
                aria-label="{item.label}"
                onclick="{() => navigateToPage(item.route)}">
                <i class="{item.icon} text-base"></i>
            </button>

            <span class="flex-grow"></span>

            <div if="{state.isAdmin}" class="dropdown dropdown-end flex-shrink-0">
                <label tabindex="0" role="button"
                       aria-label="{locale?.t('nav_configuration')}"
                       class="btn btn-sm {isActiveConfig() ? 'btn-primary' : 'btn-ghost'} gap-1 cursor-pointer">
                    <i class="icon-metalark-settings text-base" aria-hidden="true"></i>
                    <svg class="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"></path>
                    </svg>
                </label>
                <ul tabindex="0" class="dropdown-content menu p-2 shadow bg-base-100 rounded-box w-52 mt-1 z-[100]">
                    <template each="{item in state.configItems}">
                        <li>
                            <button type="button" onclick="{() => navigateToPage(item.route)}" class="{isActive(item.route) ? 'active' : ''}">
                                <i class="{item.icon}"></i>
                                <span>{item.label}</span>
                            </button>
                        </li>
                    </template>
                </ul>
            </div>
        </div>
    </div>

    <!-- Mobile Navigation: full-width dropdown listing all items + Configuration section -->
    <div class="md:hidden bg-gray-100 shadow-sm border-b border-gray-200 mb-6">
        <div class="dropdown w-full">
            <label tabindex="0" class="btn btn-sm btn-ghost w-full justify-between rounded-none cursor-pointer">
                <span class="flex items-center gap-2 text-sm">
                    <i class="{getCurrentIcon()}"></i>
                    <span>{getCurrentLabel()}</span>
                </span>
                <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"></path>
                </svg>
            </label>
            <ul tabindex="0" class="dropdown-content menu p-2 shadow bg-base-100 rounded-box w-full max-h-96 overflow-y-auto z-[100]">
                <template each="{item in state.topItems}">
                    <li>
                        <button
                            type="button"
                            onclick="{() => navigateToPage(item.route)}"
                            class="{isActive(item.route) ? 'active' : ''} text-xs py-1 px-2 min-h-0">
                            <i class="{item.icon}"></i>
                            <span>{item.label}</span>
                        </button>
                    </li>
                </template>

                <virtual if="{state.isAdmin}">
                    <li class="menu-title mobile-menu-title">
                        <span class="text-xs flex items-center gap-1"><i class="icon-metalark-settings"></i> {locale?.t('nav_configuration')}</span>
                    </li>
                    <template each="{item in state.configItems}">
                        <li>
                            <button
                                type="button"
                                onclick="{() => navigateToPage(item.route)}"
                                class="{isActive(item.route) ? 'active' : ''} text-xs py-1 ps-6 pe-2 min-h-0">
                                <i class="{item.icon}"></i>
                                <span>{item.label}</span>
                            </button>
                        </li>
                    </template>
                </virtual>
            </ul>
        </div>
    </div>

    <script>
        export default {
            state: {
                topItems: [],
                configItems: [],
                currentRoute: '',
                isAdmin: false
            },

            async onMounted() {
                this.initializeItems();
                this.setCurrentRoute();
                this.handleHashChange = () => this.setCurrentRoute();
                window.addEventListener('hashchange', this.handleHashChange);

                try {
                    const isAdmin = await this.tools.hasAnyRole(['SYSTEM_ADMIN', 'CUSTOMER_ADMIN']);
                    this.update({ isAdmin });
                } catch (err) {
                    console.warn('[ContentNavBar] Failed to resolve role for Configuration menu:', err);
                }

                this.setupDropdownHoverAreas();
            },

            onUnmounted() {
                if (this.handleHashChange) {
                    window.removeEventListener('hashchange', this.handleHashChange);
                }
            },

            initializeItems() {
                this.update({
                    topItems: [
                        {
                            id: 'content',
                            label: this.locale?.t('content_contentconsole'),
                            icon: 'icon-metalark-edit-note',
                            route: 'content'
                        },
                        {
                            id: 'deep-search',
                            label: this.locale?.t('content_deepsearch'),
                            icon: 'icon-metalark-manage-search',
                            route: 'content/deep-search'
                        },
                        {
                            id: 'bulk-edit',
                            label: this.locale?.t('content_bulkedit'),
                            icon: 'icon-metalark-metadata',
                            route: 'content/bulk-edit'
                        },
                        {
                            id: 'keywords',
                            label: this.locale?.t('content_keywords'),
                            icon: 'icon-circle',
                            route: 'content/keywords'
                        },
                        {
                            id: 'migration',
                            label: this.locale?.t('migration_nav'),
                            icon: 'icon-metalark-migration',
                            route: 'content/migration'
                        }
                    ],
                    configItems: [
                        {
                            id: 'customer-attributes',
                            label: this.locale?.t('nav_attributemanager'),
                            icon: 'icon-metalark-list',
                            route: 'customer-attributes'
                        },
                        {
                            id: 'customer-tags',
                            label: this.locale?.t('nav_customertags'),
                            icon: 'icon-metalark-tag',
                            route: 'customer-tags'
                        },
                        {
                            id: 'customer-skills',
                            label: this.locale?.t('nav_customerskills'),
                            icon: 'icon-metalark-skills',
                            route: 'customer-skills'
                        },
                        // Content Repositories: cloud-repository
                        // configuration scoped to the active workspace.
                        // Routes into pages/content-repositories.tag,
                        // which embeds the Connections / Pending Files
                        // / File Rules / Sync Activity sub-pills (same
                        // surfaces that used to live on the
                        // Customer 360 → Workspaces tab pre-METALARK-407).
                        // Slice context comes from the session; no
                        // explicit prop wiring required.
                        {
                            id: 'content-repositories',
                            label: this.locale?.t('nav_contentrepositories'),
                            icon: 'icon-metalark-link',
                            route: 'content-repositories'
                        }
                    ]
                });
            },

            setupDropdownHoverAreas() {
                setTimeout(() => {
                    const dropdowns = this.root.querySelectorAll('.content-dropdown-item');
                    const dropdownData = [];
                    let zIndexCounter = 50;

                    let lastMouseX = 0;
                    let lastMouseY = 0;

                    document.addEventListener('mousemove', (e) => {
                        lastMouseX = e.clientX;
                        lastMouseY = e.clientY;

                        dropdownData.forEach(data => {
                            if (data.content.style.display === 'block') {
                                const buttonRect = data.button.getBoundingClientRect();
                                const contentRect = data.content.getBoundingClientRect();

                                const minLeft = Math.min(buttonRect.left, contentRect.left) - 25;
                                const maxRight = Math.max(buttonRect.right, contentRect.right) + 25;
                                const minTop = Math.min(buttonRect.top, contentRect.top) - 20;
                                const maxBottom = Math.max(buttonRect.bottom, contentRect.bottom) + 20;

                                const inZone = lastMouseX >= minLeft && lastMouseX <= maxRight &&
                                               lastMouseY >= minTop && lastMouseY <= maxBottom;

                                if (!inZone && !data.closeScheduled) {
                                    data.closeScheduled = true;
                                    data.closeTimeout = setTimeout(() => {
                                        data.content.style.display = 'none';
                                        data.content.style.visibility = 'hidden';
                                        data.content.style.opacity = '0';
                                        data.button.setAttribute('aria-expanded', 'false');
                                        data.closeScheduled = false;
                                    }, 300);
                                } else if (inZone && data.closeScheduled) {
                                    clearTimeout(data.closeTimeout);
                                    data.closeScheduled = false;
                                }
                            }
                        });
                    });

                    dropdowns.forEach(dropdown => {
                        const button = dropdown.querySelector('button');
                        const content = dropdown.querySelector('.content-dropdown-menu');

                        if (!button || !content) return;

                        const data = { dropdown, button, content, closeTimeout: null, closeScheduled: false };
                        dropdownData.push(data);

                        button.addEventListener('mouseenter', () => {
                            dropdownData.forEach(d => {
                                if (d !== data && d.content.style.display === 'block') {
                                    d.content.style.display = 'none';
                                    d.content.style.visibility = 'hidden';
                                    d.content.style.opacity = '0';
                                    d.button.setAttribute('aria-expanded', 'false');
                                    clearTimeout(d.closeTimeout);
                                    d.closeScheduled = false;
                                }
                            });

                            clearTimeout(data.closeTimeout);
                            data.closeScheduled = false;
                            content.style.display = 'block';
                            content.style.visibility = 'visible';
                            content.style.opacity = '1';
                            content.style.zIndex = ++zIndexCounter;
                            button.setAttribute('aria-expanded', 'true');
                        });

                        content.addEventListener('mouseenter', () => {
                            clearTimeout(data.closeTimeout);
                            data.closeScheduled = false;
                            content.style.display = 'block';
                            content.style.visibility = 'visible';
                            content.style.opacity = '1';
                            content.style.zIndex = ++zIndexCounter;
                            button.setAttribute('aria-expanded', 'true');
                        });
                    });
                }, 100);
            },

            // Keyboard toggle: click handler on the dropdown trigger button.
            // Opens/closes the menu and keeps aria-expanded in sync. Mouse
            // users get the hover behavior set up by setupDropdownHoverAreas;
            // keyboard users get this path via Enter/Space on the button.
            toggleDropdown(buttonEl) {
                const container = buttonEl.closest('.content-dropdown-item');
                if (!container) return;
                const content = container.querySelector('.content-dropdown-menu');
                if (!content) return;
                const isOpen = content.style.display === 'block';
                if (isOpen) {
                    this.closeDropdownEl(content, buttonEl);
                } else {
                    this.openDropdownEl(content, buttonEl);
                }
            },

            openDropdownEl(content, buttonEl) {
                content.style.display = 'block';
                content.style.visibility = 'visible';
                content.style.opacity = '1';
                if (buttonEl) buttonEl.setAttribute('aria-expanded', 'true');
            },

            closeDropdownEl(content, buttonEl) {
                content.style.display = 'none';
                content.style.visibility = 'hidden';
                content.style.opacity = '0';
                if (buttonEl) buttonEl.setAttribute('aria-expanded', 'false');
            },

            // Escape closes and returns focus to the trigger button.
            handleDropdownKeydown(e) {
                if (e.key !== 'Escape') return;
                const container = e.currentTarget;
                const button = container.querySelector('button[aria-haspopup]');
                const content = container.querySelector('.content-dropdown-menu');
                if (!content || content.style.display !== 'block') return;
                e.preventDefault();
                this.closeDropdownEl(content, button);
                if (button) button.focus();
            },

            // Close when focus moves outside the dropdown container.
            handleDropdownFocusout(e) {
                const container = e.currentTarget;
                setTimeout(() => {
                    if (!container.contains(document.activeElement)) {
                        const button = container.querySelector('button[aria-haspopup]');
                        const content = container.querySelector('.content-dropdown-menu');
                        if (content && content.style.display === 'block') {
                            this.closeDropdownEl(content, button);
                        }
                    }
                }, 0);
            },

            setCurrentRoute() {
                const hash = window.location.hash || '#content';
                const route = hash.replace(/^#\/?/, '').split('?')[0];
                this.update({ currentRoute: route });
            },

            isActive(route) {
                const current = this.state.currentRoute;
                if (!current) return false;

                const allItems = [...this.state.topItems, ...this.state.configItems];
                let longestMatch = '';
                for (const item of allItems) {
                    if (current === item.route ||
                        current.startsWith(item.route + '/') ||
                        current.startsWith(item.route + '?')) {
                        if (item.route.length > longestMatch.length) {
                            longestMatch = item.route;
                        }
                    }
                }

                return route === longestMatch;
            },

            isActiveConfig() {
                return this.state.configItems.some(item => this.isActive(item.route));
            },

            getActiveConfigItem() {
                return this.state.configItems.find(item => this.isActive(item.route));
            },

            getActiveConfigIcon() {
                return this.getActiveConfigItem()?.icon || 'icon-metalark-settings';
            },

            getConfigBreadcrumbLabel() {
                const active = this.getActiveConfigItem();
                const configLabel = this.locale?.t('nav_configuration');
                if (!active) return configLabel;
                return `${configLabel} > ${active.label}`;
            },

            findCurrentItem() {
                const all = [...this.state.topItems, ...this.state.configItems];
                return all.find(item => this.isActive(item.route));
            },

            getCurrentIcon() {
                return this.findCurrentItem()?.icon || 'icon-metalark-edit-note';
            },

            getCurrentLabel() {
                if (this.isActiveConfig()) {
                    return this.getConfigBreadcrumbLabel();
                }
                return this.findCurrentItem()?.label || this.locale?.t('content_contentconsole');
            },

            navigateToPage(route) {
                this.tools.navigateTo(route);
                if (document.activeElement) {
                    document.activeElement.blur();
                }
            }
        }
    </script>

    <style>
        .content-dropdown-item {
            position: relative;
        }

        .content-dropdown-menu {
            position: absolute;
            top: 100%;
            right: 0;
            display: none;
            visibility: hidden;
            opacity: 0;
            transition: opacity 0.15s ease-out, visibility 0.15s ease-out;
            margin-top: 0;
            min-width: 100%;
            width: max-content;
            z-index: 50;
        }

        .menu li > a.active {
            background-color: hsl(var(--p));
            color: hsl(var(--pc));
            font-weight: 600;
        }

        .dropdown-content .menu li > a.active {
            background-color: hsl(var(--p));
            color: hsl(var(--pc)) !important;
            font-weight: 600;
        }

        .menu li.menu-title {
            padding: 0.25rem 0;
            margin-top: 0.5rem;
        }

        .menu li.menu-title:first-child {
            margin-top: 0;
        }

        .menu li.menu-title > span {
            color: hsl(var(--bc) / 0.6);
            font-weight: 600;
        }

        .mobile-menu-title {
            padding: 0.25rem 0.5rem !important;
            margin-top: 0 !important;
            margin-bottom: 0.25rem !important;
        }
    </style>
</content-nav-bar>
